module.exports = __webpack_public_path__ + "static/media/about_inner_vision.c3271964.png";